import { faUsers } from "@fortawesome/pro-regular-svg-icons/faUsers";
import PropTypes from "prop-types";
import React, { Fragment, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import Card from "reactstrap/es/Card";
import Col from "reactstrap/es/Col";
import Row from "reactstrap/es/Row";

// App
import {
  ButtonAdd,
  ContentBody,
  ContentErrors,
  ContentHeader,
  ContentHeaderButtons,
  ContentHeaderTitle,
  Error403,
} from "../../core/components";
import { ROUTE_USER_ADD } from "../../../constants";

// Auth
import { usePermission } from "../../auth/hooks/usePermission";

// User
import { gridChangeFilter, gridChangePagination, gridChangeSort, gridDelete, gridFetch } from "../actions/user";
import { UserGrid } from "../components";

const UserPageList = (props) => {
  const { gridErrors } = props;
  const [hasPermission] = usePermission();
  const { t } = useTranslation();

  useEffect(() => {
    document.title = t("title.users");
  }, []);

  // Kontrola opravneni
  if (!hasPermission("user.view")) {
    return <Error403 />;
  }

  return (
    <Fragment>
      <ContentHeader>
        <ContentHeaderTitle icon={faUsers} title={t("title.users")} />
        <ContentHeaderButtons>
          {hasPermission("user.create") && <ButtonAdd text={t("action.add")} to={ROUTE_USER_ADD} />}
        </ContentHeaderButtons>
      </ContentHeader>

      <ContentErrors errors={gridErrors} />

      <ContentBody>
        <Row>
          <Col>
            <Card>
              <UserGrid {...props} />
            </Card>
          </Col>
        </Row>
      </ContentBody>
    </Fragment>
  );
};

UserPageList.propTypes = {
  gridChangeFilter: PropTypes.func.isRequired,
  gridChangePagination: PropTypes.func.isRequired,
  gridChangeSort: PropTypes.func.isRequired,
  gridData: PropTypes.array.isRequired,
  gridDataTotal: PropTypes.number.isRequired,
  gridDelete: PropTypes.func.isRequired,
  gridErrors: PropTypes.array.isRequired,
  gridFetch: PropTypes.func.isRequired,
  gridIsDeleting: PropTypes.bool.isRequired,
  gridIsFetching: PropTypes.bool.isRequired,
  gridPage: PropTypes.number.isRequired,
  gridPageSize: PropTypes.number.isRequired,
  gridSortField: PropTypes.string.isRequired,
  gridSortOrder: PropTypes.string.isRequired,
};

const mapDispatchToProps = {
  gridChangeFilter,
  gridChangePagination,
  gridChangeSort,
  gridDelete,
  gridFetch,
};

const mapStateToProps = (state) => ({
  gridData: state.user.gridData,
  gridDataTotal: state.user.gridDataTotal,
  gridIsDeleting: state.user.gridIsDeleting,
  gridErrors: state.user.gridErrors,
  gridIsFetching: state.user.gridIsFetching,
  gridPage: state.user.gridPage,
  gridPageSize: state.user.gridPageSize,
  gridSortField: state.user.gridSortField,
  gridSortOrder: state.user.gridSortOrder,
});

export default connect(mapStateToProps, mapDispatchToProps)(UserPageList);
